import { useQueryClient } from '@tanstack/react-query';

import { CachedBonuses } from '../../../../../types/bonus';
import { QueryKey } from '../../hooks/types';
import { CachedProfileBonuses, removeCommentFromFeed, removeCommentFromProfile } from './bonus';

export const useRemoveCommentFromQueriesData = () => {
	const queryClient = useQueryClient();

	return (id: string) => {
		queryClient.setQueriesData<CachedBonuses>([QueryKey.BonusesInfinite], (cached) => removeCommentFromFeed(id, cached));
		queryClient.setQueriesData<CachedProfileBonuses>([QueryKey.ProfileBonuses], (cached) => removeCommentFromProfile(id, cached));
	};
};
